import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { fileExtensionStylingMap, genericFile } from "~/components/FileExtensionPreview/types";
import { THUMBNAIL_HEIGHT } from "../../../shared/constants";
export const VersionFileThumbnail = /*#__PURE__*/ memo((param)=>{
    let { ext, isCurrentVersion } = param;
    const extStyles = useMemo(()=>{
        const normalizedExt = (ext === null || ext === void 0 ? void 0 : ext.toLowerCase()) || ""; // to support e.g. JPG
        return normalizedExt in fileExtensionStylingMap ? fileExtensionStylingMap[normalizedExt] : genericFile;
    }, [
        ext
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("asset-modal-version-thumbnail pointer-events-none box-border flex h-[THUMBNAIL_HEIGHT] w-full items-center justify-center overflow-hidden rounded-2 border border-black", isCurrentVersion ? "shadow-[0px_0px_0px_2px] shadow-grey-10" : ""),
        style: {
            height: THUMBNAIL_HEIGHT,
            color: extStyles.iconColor,
            backgroundColor: extStyles.bgColor
        },
        children: /*#__PURE__*/ _jsx(extStyles.iconComponent, {
            className: "block w-8"
        })
    });
});
VersionFileThumbnail.displayName = "VersionFileThumbnail";
